import {regNavn} from "felles/tjenester/tredjepartsTjenestenavn";
import {IController, IModule, IScope} from "angular";
import {l} from "types/typescriptdefinisjoner_lederplan";
import _ from "lodash";
import {gettextCatalog} from "angular-gettext";
import {OppgaveRessurs} from "felles/tjenester/ressurser/OppgaveRessurs";
import {MeldingTilBruker} from "felles/tjenester/MeldingTilBruker";
import {ModelloppdateringTjeneste} from "web/tjenester/ModelloppdateringTjeneste";
import {PagineringMetadata} from "../../OppgaverKontroller";

require('./oppgaveliste.scss');

export class OppgavelisteKontroller implements IController {

    static registrerKomponent(angular: IModule) {
        angular
          .component('woOppgaveliste', {
              bindings: {oppgaver: '<', forelderId: '<', metadata: '<', sortering: '<', visForelder: '@', utfoerPaginering: '&', utfoerSortering: '&', oppdaterStatus: '&', oppgaveModellOppdatert: '&'},
              controller: OppgavelisteKontroller.forInjisering(),
              template: require('./oppgaveliste.html')
          });
    }
    
    static forInjisering() {
        return [
            regNavn.ng.$scope,
            ModelloppdateringTjeneste.regNavn,
            MeldingTilBruker.regNavn,
            OppgaveRessurs.regNavn,
            regNavn.gettext.gettextCatalog,
            OppgavelisteKontroller
        ]
    }

    constructor(private $scope: IScope,
                private modelloppdatering: ModelloppdateringTjeneste,
                private meldingTilBruker: MeldingTilBruker,
                private oppgaveRessurs: OppgaveRessurs,
                private gettextCatalog: gettextCatalog) {
        this.lyttTilNyOppgave();
        this.lyttTilOppgaveOppdatert();
        this.lyttTilOppgaveSlettet();
    }

    oppgaver: l.OppgaveModell[]; //satt via bindings
    forelderId: string; //settes via bindings
    visForelder: 'true' | 'false'; //settes via bindings (undefined tolkes som true)
    
    sortering: l.OppgaveSorteringsspesifikasjon;
    metadata:PagineringMetadata
    
    kolonneMapping = { "frist" : l.Oppgavesorteringskolonne.frist, "tittel": l.Oppgavesorteringskolonne.tittel, "status": l.Oppgavesorteringskolonne.status, "bruker": l.Oppgavesorteringskolonne.bruker }

    utfoerSortering: (args: { spesifikasjon: l.OppgaveSorteringsspesifikasjon }) => void; //satt via bindings
    utfoerPaginering: (args: {spesifikasjon: l.OppgavePagineringSpesifikasjon}) => void;
    oppdaterStatus: (args: { spesifikasjon:l.OppgaveStatusSpesifikasjon  }) => void;
    oppgaveModellOppdatert: (args: {spesifikasjon: {oppgave: l.OppgaveModell}}) => void;

    statusOppdatering(statusOppdatering) {
        this.oppdaterStatus({spesifikasjon: statusOppdatering});
    }
    

    // Paginering
    paginer(spesifikasjon: l.OppgavePagineringSpesifikasjon) {
        this.utfoerPaginering({spesifikasjon: spesifikasjon});
    }

    // Sortering
    sorter(kolonne:string) {
        let mapping = this.kolonneMapping[kolonne];
        const spesifikasjon = {retning: this.sortering.retning === l.Sortering.stigende ? l.Sortering.synkende : l.Sortering.stigende, kolonne: mapping};
        this.utfoerSortering({spesifikasjon: spesifikasjon})
    }

    erSynkende() {
        return this.sortering.retning === l.Sortering.synkende;
    }

    erKolonneInaktiv(kolonnenavn:string) {
        return this.sortering.kolonne !== this.kolonneMapping[kolonnenavn];
    }

    // hjelpemetoder

    // modelloppdateringslyttere

    private lyttTilNyOppgave() {
        this.modelloppdatering.vedNyOppgave(
          oppgaveOgMøte => this.forelderId &&
            this.forelderId == oppgaveOgMøte.oppgaveForelderId &&
            !_(this.oppgaver).some({id: oppgaveOgMøte.oppgaveId}),
          this.$scope,
          oppgaveOgMøte => {
              this.oppgaveRessurs.hent(oppgaveOgMøte.oppgaveId).$promise.then(oppgave => {
                  if (_(this.oppgaver).some({id: oppgave.id})) return;
                  this.oppgaver.push(oppgave);
                  this.meldingTilBruker.infomelding(this.gettextCatalog.getString("Ny oppgave registrert"));
              });
          });
    }

    private lyttTilOppgaveOppdatert() {
        this.modelloppdatering.vedOppdatertOppgave(
          oppgaveOgMøte => _(this.oppgaver).some({id: oppgaveOgMøte.oppgaveId}),
          this.$scope,
          oppgaveOgMøte => {
              this.oppgaveRessurs.hent(oppgaveOgMøte.oppgaveId).$promise.then(oppgave => {
                  this.oppgaveModellOppdatert({spesifikasjon: {oppgave: oppgave}});
                  this.oppgaver[_(this.oppgaver).findIndex({id: oppgave.id})] = oppgave;
                  this.meldingTilBruker.infomelding(this.gettextCatalog.getString("Oppgave oppdatert"));
              });
          });
    }

    private lyttTilOppgaveSlettet() {
        this.modelloppdatering.vedSlettetOppgave(
          oppgaveOgMøte => _(this.oppgaver).some({id: oppgaveOgMøte.oppgaveId}),
          this.$scope,
          oppgaveOgMøte => {
              _.remove(this.oppgaver, {id: oppgaveOgMøte.oppgaveId});
              this.meldingTilBruker.infomelding(this.gettextCatalog.getString("Oppgave slettet"));
          });
    }
}
